import { QueryClientProvider } from "@tanstack/react-query"
import { GoogleOAuthProvider } from "@react-oauth/google"
import { useDarkMode } from "@/hooks/useDarkMode"
import { queryClient } from "@/lib/utils/query"
import { DevToolsInitializer } from "@/lib/store/DevToolsInitializer"

function DarkModeInitializer() {
  useDarkMode()
  return null
}

export default function Providers({ children }: { children: React.ReactNode }) {
  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID

  return (
    <QueryClientProvider client={queryClient}>
      <GoogleOAuthProvider clientId={googleClientId}>
        <DarkModeInitializer />
        <DevToolsInitializer />
        {children}
      </GoogleOAuthProvider>
    </QueryClientProvider>
  )
}
